import useAppStore from '@/store/app';
import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

export default function WarehouseLayout() {
  const { setNavigation } = useAppStore();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setNavigation({
      base: '/warehouse',
      items: [
        {
          title: 'Labels',
          slug: 'labels',
        },
        {
          title: 'Lieferungen',
          slug: 'shipments',
        },
        {
          title: 'Buckets',
          slug: 'buckets',
        },
      ],
    });
    if (pathname === '/warehouse') navigate('/warehouse/labels');
  }, []);

  return (
    <Box sx={{ display: 'flex', flex: 1, height: '100%' }}>
      <Box sx={{ flexGrow: 1, backgroundColor: 'rgba(0, 0, 0, 0.01)', overflow: 'auto' }}>
        <Outlet />
      </Box>
    </Box>
  );
}
